<div class="main-content table-page table-page--compact planes-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Planes</h1>
        <p>Módulos contratados, con licencias y vigencia: sólo los vigentes con cupo libre se reparten; para ampliar o renovar, contacte a Solser.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="consultar()">
          <i class="material-icons">refresh</i>
          <span>Actualizar</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar" *ngIf="planes.length > 0">
        <div class="planes-page__resumen">
          <strong>{{ vigentes }}</strong> {{ vigentes === 1 ? "módulo vigente" : "módulos vigentes" }}
          <span class="table-page__subtext" *ngIf="planes.length - vigentes > 0"> · {{ planes.length - vigentes }} vencido(s)</span>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="planes.length > 0; else planesEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Módulo</th>
              <th>Licencias</th>
              <th>Vence</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of planes">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ plan.sitio }}</strong>
                  <span class="table-page__subtext">Plan {{ plan.id }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text planes-page__cupo">
                    {{ plan.usuariosAsignados }} de {{ plan.cantidadUsuarios }} ocupadas
                  </span>
                  <span class="table-page__subtext" *ngIf="!cupoLleno(plan)">
                    {{ disponibles(plan) }} disponibles<ng-container *ngIf="esAsistencia(plan)"> · cuenta a quien tiene modalidad o perfil</ng-container>
                  </span>
                  <span class="table-page__subtext planes-page__lleno" *ngIf="cupoLleno(plan)">
                    Cupo lleno: no se puede dar de alta a nadie más en este módulo
                  </span>
                </div>
              </td>
              <td><span class="table-page__text">{{ soloFecha(plan.vigencia) }}</span></td>
              <td><span [class]="claseEstatus(plan)">{{ etiquetaEstatus(plan) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #planesEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else planesLoadingState">
          <span class="material-icons">workspace_premium</span>
          <h3>Su empresa no tiene ningún plan</h3>
          <p>Sin planes no hay módulos que repartir. Contacte a Solser para contratar el primero.</p>
        </div>
      </ng-template>

      <ng-template #planesLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando planes</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
